var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "telephonic-screening px-4 pt-3 pb-5" },
    [
      _c("form", { staticClass: "pt-0", attrs: { method: "post" } }, [
        _c("div", [
          _c("input", {
            attrs: { type: "hidden", name: "_csrfToken" },
            domProps: { value: _vm.csrfToken }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "fail_reason" },
            domProps: { value: _vm.fail_reason }
          }),
          _vm._v(" "),
          _c("div", [
            _c("p", [
              _vm._v("Start date scheduled for: "),
              _vm.jobApplication.job_start_result &&
              _vm.jobApplication.job_start_result.start_datetime
                ? _c("span", { staticClass: "fw-bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.scheduleDate(
                          _vm.jobApplication.job_start_result.start_datetime
                        )
                      )
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-2" }, [
              _vm._v("Current Status: "),
              _c("strong", [_vm._v(_vm._s(_vm.startStatus))]),
              _vm._v(" "),
              _vm.logs !== null && _vm.logs !== ""
                ? _c("span", [
                    _vm._v(
                      "\n                         (Updated By " +
                        _vm._s(_vm.logs.user.first_name) +
                        " " +
                        _vm._s(_vm.logs.user.last_name) +
                        " - " +
                        _vm._s(
                          _vm.convertDate(_vm.logs.created, "YYYY-MM-DD HH:ss")
                        ) +
                        ")\n                    "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("strong", [
              _vm._v(
                "Did the candidate start working following their onboarding session?"
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.jobApplication.job_start_result
          ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
              _c(
                "div",
                {
                  staticClass: "cell large-6 pe-5",
                  staticStyle: { "border-right": "solid 1px #D1D1D1" }
                },
                [
                  _c("div", { staticClass: "d-flex align-items-start gap-4" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button mt-4",
                        attrs: {
                          type: "submit",
                          name: "job_start_result[status]",
                          value: "pass"
                        }
                      },
                      [_vm._v("YES - PROCEED TO START")]
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "button secondary-btn mt-4",
                          attrs: {
                            type: "submit",
                            name: "job_start_result[status]",
                            value: "explain"
                          }
                        },
                        [
                          _vm._v(
                            "NO - ASK CANDIDATE FOR\n                            EXPLANATION"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button secondary-btn mt-2",
                          attrs: {
                            type: "submit",
                            name: "job_start_result[status]",
                            value: "reschedule"
                          }
                        },
                        [
                          _vm._v(
                            "NO - RESCHEDULE\n                            ONBOARDING"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button secondary-btn mt-2",
                          attrs: {
                            type: "button",
                            name: "job_start_result[status]",
                            value: "recycle"
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleModal("recycleModal")
                            }
                          }
                        },
                        [_vm._v("NO - RECYCLE CANDIDATE")]
                      ),
                      _vm._v(" "),
                      _c("button", {
                        ref: "failedButton",
                        staticClass: "d-none",
                        attrs: {
                          value: "fail",
                          name: "job_start_result[status]"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button alert mt-2",
                          attrs: {
                            type: "button",
                            name: "job_start_result[status]",
                            value: "recycle"
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleModal("failModal")
                            }
                          }
                        },
                        [_vm._v("NO - DECLINE CANDIDATE")]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "cell large-6 px-4" }, [
                _c("div", { staticClass: "small-12" }, [
                  _c("label", { staticClass: "fw-bold" }, [
                    _vm._v("Reason(s) for candidate not showing up:")
                  ]),
                  _c("br"),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.jobApplication.job_start_result.explanation) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _vm.sageLog
                  ? _c("div", { staticClass: "small-12 mt-5" }, [
                      _c("label", { staticClass: "fw-bold" }, [
                        _vm._v("Sage sync status:")
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _vm.sageLog.completed
                        ? _c("span", { staticClass: "text-green" }, [
                            _vm._v("Synced")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.sageLog.completed && _vm.sageLog.failed > 0
                        ? _c("span", { staticClass: "text-red" }, [
                            _vm._v("Failed")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.sageLog.completed &&
                      _vm.sageLog.failed > 0 &&
                      _vm.sageLog.log_entries[0]
                        ? _c("div", { staticClass: "mt-4" }, [
                            _c("label", { staticClass: "fw-bold" }, [
                              _vm._v("Parsed Sage Response:")
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "ul",
                              _vm._l(
                                _vm.parseSageResponse(
                                  "{" +
                                    _vm.sageLog.log_entries[0].response_data
                                      .split("{")
                                      .slice(1)
                                      .join("{")
                                ).businessRules,
                                function(rule) {
                                  return _c("li", { key: rule.PropertyName }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(rule.PropertyFriendlyName) +
                                        "\n                                "
                                    ),
                                    rule.WarningRulesCollection
                                      ? _c(
                                          "ul",
                                          _vm._l(
                                            rule.WarningRulesCollection,
                                            function(message) {
                                              return _c(
                                                "li",
                                                { key: message },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(message.Message) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    rule.ErrorRulesCollection
                                      ? _c(
                                          "ul",
                                          _vm._l(
                                            rule.ErrorRulesCollection,
                                            function(message) {
                                              return _c(
                                                "li",
                                                { key: message },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(message.Message) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e()
                                  ])
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("label", { staticClass: "fw-bold" }, [
                              _vm._v("Error Response:")
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _vm.sageLog.log_entries[0].response_data.includes(
                              "{"
                            )
                              ? _c("div", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        "{" +
                                          _vm.sageLog.log_entries[0].response_data
                                            .split("{")
                                            .slice(1)
                                            .join("{")
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              : _c("div", [
                                  _c("pre", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.sageLog.log_entries[0].response_data
                                      )
                                    )
                                  ])
                                ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("label", { staticClass: "fw-bold" }, [
                                _vm._v("Payload Sent:")
                              ]),
                              _c("br"),
                              _vm._v(" "),
                              _c("pre", [
                                _vm._v(
                                  _vm._s(
                                    _vm.sageLog.log_entries[0].request_data
                                  )
                                )
                              ])
                            ])
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            ])
          : _c("div", [_vm._v("\n            No starting scheduled\n        ")])
      ]),
      _vm._v(" "),
      _c("recycle-modal", {
        ref: "recycleModal",
        attrs: {
          "job-application": _vm.jobApplication,
          "csrf-token": _vm.csrfToken
        }
      }),
      _vm._v(" "),
      _c("fail-modal", {
        ref: "failModal",
        attrs: { "job-application": _vm.jobApplication },
        on: { submit: _vm.fail }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3aecf996", { render: render, staticRenderFns: staticRenderFns })
  }
}